module.exports = __webpack_public_path__ + "img/jyServiceItem3.1eef2499.png";